// extracted by mini-css-extract-plugin
export default {"Vcard":"Transaction_Vcard__AgJfH","VAcctTxt":"Transaction_VAcctTxt__t0y0e","VFundTxt":"Transaction_VFundTxt__DifIb","VBank":"Transaction_VBank__YdsUw"};